export const initialValuesIngTeam = {
	diagnostiqueur: "",
	diagnostiqueurHour: "0",
	diagnostiqueurSupport: "",
	diagnostiqueurDateStart: "",
	diagnostiqueurDateEnd: "",
	ingenieur: "",
	ingenieurHour: "0.25",
	ingenieurSupport: "",
	ingenieurDateStart: "",
	ingenieurDateEnd: "",
	verificateur: "",
	verificateurHour: "0.25",
	verificateurSupport: "",
	verificateurDateStart: "",
	verificateurDateEnd: "",
	manager: "",
	managerHour: "0.25",
	managerSupport: "",
	managerDateStart: "",
	managerDateEnd: "",
}
